import { type PropsWithChildren, type ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { useApp } from '../hooks/AppProvider.tsx';
import { hasEventGallery } from '../utils/hasEventGallery';

const RedirectWhenNoGallery = ({ children }: PropsWithChildren): ReactElement => {
  const [{ event }] = useApp();

  if (!hasEventGallery(event?.gallery)) {
    return <Navigate to=".." replace />;
  }

  return <>{children}</>;
};

export default RedirectWhenNoGallery;
